import { supabase } from '../supabase';
import { isFeatureOn } from '../utils/features/isFeatureOn';

/**
 * The caller's company feature switches (RD-PLAT-016): `{ ai: true, ... }`,
 * one boolean per feature key, resolved by the database from the platform's
 * rollout + the company's plan + any per-company override. The tenant comes
 * from the caller's own membership on the server — never passed from here.
 *
 * FAILS CLOSED: any error, throw or malformed answer is `{}`, which reads as
 * "no feature on". A feature is on only when the server said `=== true`.
 */
export async function getMyFeatures() {
  try {
    const { data, error } = await supabase.rpc('get_my_features');
    if (error || data == null || typeof data !== 'object' || Array.isArray(data)) return {};
    const features = {};
    Object.keys(data).forEach((key) => {
      features[key] = data[key] === true;
    });
    return features;
  } catch {
    return {};
  }
}

export { isFeatureOn };
